
import React, { memo } from 'react';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Loader } from 'components';
import { FormattedMessage } from 'react-intl';
import intl from './intl/RegistrationCompleteDashboard';
import { Typography } from 'components/ui';
import { GotoTrulyButton } from './GotoTrulyButton';
import submittedCompany from 'assets/images/submittedCompany.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(0, 4),
      backgroundColor: theme.palette.background.default,
    },
    backgroundColor: theme.palette.primary.contrastText,
    width: "100%",
    textAlign: "center",
  },
  main: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(0, 1),
    [theme.breakpoints.up("md")]: {
      borderTopLeftRadius: theme.spacing(1.5),
      borderTopRightRadius: theme.spacing(1.5),
    },

    backgroundColor: theme.palette.primary.contrastText,
    minHeight: `calc(100vh - ${theme.spacing(10)}px)`,
    // minHeight: `calc(100vh - 50px)`,
    // minHeight: `calc(100vh - 69px)`,
  },
  titleTxt: {
    marginTop: theme.spacing(8.25),
    marginBottom: theme.spacing(2),
  },
  titleSubTxt: {
    marginBottom: theme.spacing(4),
  },
  info1: {
    padding: theme.spacing(4),
  },
  pdMainView: {
    backgroundColor: theme.palette.grey50,
    borderRadius: theme.spacing(1),
    width: "auto",
    // height: theme.spacing(47.5),
    //height: '75%',
    flex: 1,
    margin: theme.spacing(4, 0),
    padding: theme.spacing(3, 3, 0, 3),
    display: "flex",
  },
  padSubView: {
    backgroundColor: "white",
    flex: 1,
    borderRadius: theme.spacing(1, 1, 0, 1),
  },
  iconColor: {
    color: `${theme.palette.grey500}`,
    "&.Mui-checked": {
      color: `${theme.palette.accent.main} !important`,
    },
  },
  btnDiv: {
    margin: theme.spacing(0, 1, 0, 1),
    padding: theme.spacing(0, 3),
  },
  correctionBtnDiv: {
    margin: theme.spacing(0, 1, 0, 1),
    padding: theme.spacing(0, 3),
    minWidth: theme.spacing(27),
  },
  row: {
    display: "flex",
    alignItems: "center",
  },
  lastGrid: {
    margin: theme.spacing(2, "auto", 0, "auto"),
    display: "flex",
  },
  iframePdf: {
    width: "100%",
    height: "100%",
  },
  mainWrapperDiv: {
    flex: 0.75,
    width: "90%",
    display: "flex",
    flexDirection: "column",
    // justifyContent: "center",
    alignItems: "center",
  },
  column: {
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    position: "relative"
  },
  gotoTrulyBtn: {
    paddingRight: theme.spacing(5),
    paddingBottom: theme.spacing(5),
  },
  img: {
    height: theme.spacing(32.5),
    width: theme.spacing(32.5)
  },
  subTxt: {
    margin: theme.spacing(2, 0, 0, 0)
  },
  divider: {
    width: '65%',
    margin: theme.spacing(5, 0)
  },
  bodyTxt: {
    margin: theme.spacing(0, 0, 4.5, 0)
  }
}));

function CompanyStatusSubmitted(props = {}) {
  const classes = useStyles();
  const { customerDetails, /*onInviteAsTeamAction*/ } = props;
  const customerDetailData = customerDetails.data || {};
  if (!customerDetailData || customerDetails.loading) {
    return (<Loader componentCenter />);
  }

  return (
    <Paper elevation={0} className={classes.root}>
      <div className={classes.main}>
        <div className={classes.column}>
          <div className={classes.mainWrapperDiv} >
            <img src={submittedCompany} alt="submitted_img" className={classes.img} />
            <Typography color="grey700" variant="h5"> <FormattedMessage {...intl.applicationRec} /> </Typography>
            <Typography color="grey700" variant="body1" className={classes.subTxt} > <FormattedMessage {...intl.submittedSubText} /> </Typography>
            {/* <Typography className={classes.info1} color="grey500" variant="body1"> <FormattedMessage {...intl.submittedInfoText1} /> </Typography> */}
            {/* temporarily - removing guide buttons */}
            {/* <Divider className={classes.divider} />
            <Typography color="grey700" variant="titleMobile" className={classes.bodyTxt} > <FormattedMessage {...intl.submittedBodyText} /> </Typography>
            <GuideButtons type="round" /> */}
          </div>
        </div>
        <div className={classes.gotoTrulyBtn}>
          <GotoTrulyButton />
        </div>
      </div>
    </Paper>);
}


export default memo(CompanyStatusSubmitted);
